import isEmpty from '../../is-Empty';
import validator from 'validator';

export const RestaurantMapSetupValidation = (data) => {
  let errors = {};
  let objectData = {};

  objectData.restaurant_name = !isEmpty(data.restaurant_name)
    ? data.restaurant_name
    : '';
  objectData.restaurant_address = !isEmpty(data.restaurant_address)
    ? data.restaurant_address
    : '';
  objectData.city = !isEmpty(data.city) ? data.city : '';
  objectData.area = !isEmpty(data.area) ? data.area : '';
  objectData.pinCode = !isEmpty(data.pinCode) ? data.pinCode : '';
  objectData.enquiry_email = !isEmpty(data.enquiry_email)
    ? data.enquiry_email
    : [];
  objectData.contact_detail = !isEmpty(data.contact_detail)
    ? data.contact_detail
    : [];
  objectData.country = !isEmpty(data.country) ? data.country : '';
  objectData.currency = !isEmpty(data.currency) ? data.currency : '';
  objectData.timezone = !isEmpty(data.timezone) ? data.timezone : '';
  objectData.logo_url = !isEmpty(data.logo_url) ? data.logo_url : [];
  objectData.restaurant_description = !isEmpty(data.restaurant_description)
    ? data.restaurant_description
    : '';
  objectData.things_nearby = !isEmpty(data.things_nearby)
    ? data.things_nearby
    : '';
  objectData.restaurant_pictures = !isEmpty(data.restaurant_pictures)
    ? data.restaurant_pictures
    : '';

  Object.keys(objectData).forEach((key) => {
    if (typeof objectData[key] === 'string') {
      if (validator.isEmpty(objectData[key])) {
        errors[key] = 'Field is Required';
      }
    }
  });

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const RestaurantMapSetupValidationTwo = (data) => {
  let errors = {};

  data.description = !isEmpty(data.description) ? data.description : '';
  // data.restaurant_photo = !isEmpty(data.restaurant_photo)
  //   ? data.restaurant_photo
  //   : "";

  if (validator.isEmpty(data.description)) {
    errors.description = 'Restaurant Logo is required';
  }
  // if (validator.isEmpty(data.restaurant_photo)) {
  //   errors.restaurant_photo = "Restaurant Photo is required";
  // }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
